import axios from "axios"

// get survey details
export function getSingleSurveyInfo({ id }) {
  return new Promise((resolve, reject) => {
    axios.get(`/consumer/admin/api/v1/survey/${id}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}